// Can the browser show this attachment in a tab, or must it be downloaded?
// The one client owner (BUSINESS_RULES#attachment-opens-in-browser). It must agree with
// `shouldInline` in src/routes/files.routes.js, which sets the Content-Disposition that
// actually decides — offering "Open in new tab" for a file the server forces to download
// is exactly USC-BUG-0054. html/svg/xml never open: the server serves them as plain-text
// attachments (stored-XSS guard, a735f7a0).
export function opensInBrowser(filename?: string, mimeType?: string): boolean {
  const name = String(filename || '').toLowerCase();
  const mt = String(mimeType || '').toLowerCase();

  if (/\.(html?|xhtml|xml|svgz?|mht|mhtml)$/.test(name) || /html|svg|xml/.test(mt)) return false;

  if (/\.(pdf|png|jpe?g|webp|csv)$/.test(name)) return true;
  return mt === 'application/pdf' || mt === 'text/csv' || mt.startsWith('image/');
}
